
import React, { useState } from 'react';
import JUVTriageQuiz, { ConcernTag } from './quiz/JUVTriageQuiz';
import QuizResults from './quiz/QuizResults';

const JUVQuiz = () => {
  const [showResults, setShowResults] = useState(false);
  const [quizResults, setQuizResults] = useState<{
    concerns: ConcernTag[];
    budget: string;
    timeCommitment: string;
    resultsGoal: string;
  }>({
    concerns: [],
    budget: '',
    timeCommitment: '',
    resultsGoal: ''
  });

  const handleQuizComplete = (results: typeof quizResults) => {
    setQuizResults(results);
    setShowResults(true);
  };

  const handleRetakeQuiz = () => {
    setShowResults(false);
    setQuizResults({
      concerns: [],
      budget: '',
      timeCommitment: '',
      resultsGoal: ''
    });
  };

  const handleBookTreatment = (treatmentId: string) => {
    console.log('Booking treatment:', treatmentId);
    // Integrate with your booking system here
    // This could redirect to booking page or open a modal
  };

  const handleBookBundle = (bundleId: string) => {
    console.log('Booking bundle:', bundleId);
    // Integrate with your booking system here
    // This could redirect to booking page or open a modal
  };

  if (showResults) {
    return (
      <QuizResults
        concerns={quizResults.concerns}
        budget={quizResults.budget}
        timeCommitment={quizResults.timeCommitment}
        resultsGoal={quizResults.resultsGoal}
        onRetakeQuiz={handleRetakeQuiz}
        onBookTreatment={handleBookTreatment}
        onBookBundle={handleBookBundle}
      />
    );
  }

  return <JUVTriageQuiz onComplete={handleQuizComplete} />;
};

export default JUVQuiz;
